import { useState } from 'react';

export const useForm = (initialForm = {}) => {
    const [formState, setFormState] = useState({
        acceptedFiles: [],
        fileRejections: [],
        images: [],
        ...initialForm
    });
    const [elementResetFlag, setElementResetFlag] = useState(false);

    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const onInputChangeForNumber = ({ target }) => {
        const { name, value } = target;
        const cleanValue = value.replace(/,/g, '');
        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);
        if (!validNumber) return;

        if (cleanValue === '' || cleanValue === '.') {
            setFormState(prev => ({ ...prev, [name]: value }));
            return;
        }

        let [integerPart, decimalPart] = cleanValue.split('.');
        if (decimalPart !== undefined) decimalPart = decimalPart.slice(0, 2);

        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));
        const formattedValue = decimalPart !== undefined
            ? `${formattedInteger}.${decimalPart}`
            : formattedInteger;

        setFormState({
            ...formState,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue)
        });
    };

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState(prev => ({ ...prev, acceptedFiles: arrayAccepted }));
    };

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState(prev => ({ ...prev, fileRejections: arrayRejections }));
    };

    const onResetForm = (preserveKeys = []) => {
        setFormState((prev) => {
            const preserved = preserveKeys.reduce((acc, key) => {
                acc[key] = prev[key];
                return acc;
            }, {});

            return {
                ...initialForm,
                ...preserved,

                acceptedFiles: [],
                fileRejections: [],
                images: []
            };
        });

        setElementResetFlag(prev => !prev);
    };

    // Necesario para cargar imágenes desde fetch
    const onImagesChange = (imagesArray) => {
        setFormState(prev => ({
            ...prev,
            images: imagesArray
        }));
    };

    return {
        ...formState,
        formState,
        elementResetFlag,
        setFormState,
        onInputChange,
        onInputChangeForNumber,
        onSelectSearchChange,
        onResetForm,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange,
        onImagesChange
    };
};